export default [
  // 下载中心
  {
    path: 'download-center',
    name: 'DownloadCenter',
    meta: {
      inTab: true,
      isDynamic: true,
      id: '下载中心',
      title: '下载中心'
    },
    component: () =>
      import(/* webpackChunkName: "DownloadCenter" */ '@/views/DownloadCenter/DownloadCenter.vue')
  }
];
